/**
 * integrations · busca de CEP (spec 06 §5).
 *
 * O contrato é do DigitalView, não do ViaCEP: `logradouro`, `bairro`, `cidade`,
 * `uf` — os nomes do GLOSSARIO. O adapter traduz o vocabulário do fornecedor
 * (`localidade`, `erro`) e é a única parte que muda se um dia o fornecedor mudar.
 *
 * **Falha em silêncio, por decisão** (spec 04-TELAS/3.2 e 10.2): CEP que não resolve
 * não vira erro na cara de quem digita — os campos ficam livres para digitação
 * manual. Um endereço de vila nova pode simplesmente não existir na base do
 * fornecedor, e travar o cadastro por isso pararia a operação por causa de terceiro.
 */
import { z } from 'zod'

export const cepBr = z.string().regex(/^\d{5}-?\d{3}$/, 'Use um CEP no formato 00000-000.')

export const enderecoDeCep = z.object({
  cep: z.string(),
  logradouro: z.string(),
  complemento: z.string(),
  bairro: z.string(),
  cidade: z.string(),
  uf: z.string(),
})
export type EnderecoDeCep = z.infer<typeof enderecoDeCep>

/**
 * `encontrado: false` é resposta NORMAL, com 200.
 *
 * Devolver 404 aqui faria a tela tratar "CEP inexistente" como falha de rede, e o
 * fallback offline (digitação manual) é o mesmo caminho nos dois casos.
 */
export const respostaDeCep = z.union([
  z.object({ encontrado: z.literal(true), endereco: enderecoDeCep }),
  z.object({ encontrado: z.literal(false) }),
])
export type RespostaDeCep = z.infer<typeof respostaDeCep>
